import { __awaiter, __generator } from "tslib";
import axiosInstance from "../../axiosInstance";
import endpoints from "../../endpoints";
export var getDashboardHeaderData = function () { return __awaiter(void 0, void 0, void 0, function () {
    var res;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, axiosInstance.get("".concat(endpoints.api.manageTrips.getDashboardHeaderData))];
            case 1:
                res = _a.sent();
                return [2 /*return*/, res.data.result];
        }
    });
}); };
